<template>
  <div
    class="l-footer-container"
    id="copyright"
    :class="[$route.meta.footer ? 'l-footer__bg' : '']"
  >
    <div class="c-footer__inline">
      <!-- <a
        href="http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020180410163445000002463951-SAIC_SHOW_310000-4028e4cb6ac5c06c016ad02d436004fb351&signData=MEUCIDvDH2NP3O+cT4DQjGHQz4ntln8r+N05ezSxrx21VeemAiEAgyoNy+Jtdm9UWS/Oh4EYbXqeMUHih4T5xtZ2tzMMAFg="
        target="_blank"
        class="c-footer__label c-footer__label--a"
        ><img src="../../../assets/lz2.jpg" alt="" srcset="" />
        沪ICP备18013071号</a
      > -->
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        class="c-footer__label c-footer__label--a"
        ><img src="../../../assets/lz2.jpg" alt="" srcset="" />
        沪ICP备18013071号</a
      >
      <!-- <div class="c-footer__label">沪ICP备18013071号</div> -->
      <div class="c-footer__label">
        © 2018-2019 上海笙慨信息技术有限公司. All rights reserved.
      </div>
    </div>
    <div class="c-footer__inline">
      <div class="c-footer__label">联系人：郑经理 199 2104 8820</div>
      <div class="c-footer__label">
        邮&nbsp;&nbsp;&nbsp;&nbsp;箱：back.zheng@someguy.cn
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
<style lang="scss">
@import '~common/scss/mixin';
.l-footer-container {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 171px;
  background: rgba(246, 249, 253, 1);
  z-index: 999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 19%;
  .c-footer__label {
    font-size: 14px;
    font-weight: 400;
    color: rgba(125, 148, 179, 1);
    line-height: 14px;
    padding-bottom: 15px;
    &:last-child {
      padding-bottom: 0;
    }
  }
  .c-footer__label--a {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    img {
      width: 20px;
      height: 20px;
      vertical-align: middle;
      margin-right: 4px;
    }
  }
  &.l-footer__bg {
    background: transparent;
  }
}
</style>
